import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ClientDetailPage } from '@/features/preparer/clients/ClientDetailPage';

export const ClientTab = {
  Overview: 'overview',
  UserAccounts: 'users',
  Binders: 'taxBinders',
  AuditBinders: 'auditBinders',
  Activity: 'activity',
  Notifications: 'notifications',
  AccessControl: 'access',
} as const;

export type ClientTabType = (typeof ClientTab)[keyof typeof ClientTab];

const clientDetailSearchSchema = z.object({
  // Preserve legacy `?tab=binders` deep links/bookmarks created before the
  // tax-binder rename by normalizing them to `taxBinders` before validation.
  // Remove the preprocess shim alongside the legacy `/preparer/binders` redirects.
  tab: z
    .preprocess(
      (val) => (val === 'binders' ? ClientTab.Binders : val),
      z
        .enum([
          ClientTab.Overview,
          ClientTab.UserAccounts,
          ClientTab.Binders,
          ClientTab.AuditBinders,
          ClientTab.Activity,
          ClientTab.Notifications,
          ClientTab.AccessControl,
        ])
        .optional()
    )
    .catch(ClientTab.Overview)
    .optional(),
});

export const Route = createFileRoute('/preparer/clients/$clientId')({
  validateSearch: clientDetailSearchSchema,
  component: ClientDetailPage,
});
